import { checkChanged } from "./checkChanged";
import { ITlfActionRemoveTlfComment, REMOVE_TLF_COMMENT, TlfContextProps } from "./interface";

/**
 * Removes a comment from the current TLF item.
 *
 * @param state - Current TLF context state.
 * @param action - Remove-comment action identifying the comment to delete.
 * @returns Updated state without the targeted comment.
 */
export const tlf_removeTlfComment = (
  state: TlfContextProps,
  action: ITlfActionRemoveTlfComment,
): TlfContextProps => {
  const newState = { ...state };

  if (!newState.tlfData) {
    throw new Error(`tlfContextReducer: ${REMOVE_TLF_COMMENT}: TLF data not set`);
  }

  newState.tlfData = {
    ...newState.tlfData,
    comments: newState.tlfData.comments.filter((comment) => comment.id !== action.commentId),
  };
  newState.forcePushToParent = true;
  checkChanged(newState);

  return newState;
};
